import { render } from "./Highriskbaby.vue?vue&type=template&id=24a30fe5"
import script from "./Highriskbaby.vue?vue&type=script&lang=js"
export * from "./Highriskbaby.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__